import {
  auctionBatchesAdd,
  auctionBatchesDelete,
  auctionBatchesList,
  auctionsList,
  auctionsUpdateStatus,
  auctionHistoryList
} from '@/febos/servicios/api/aduanas/auctions.api';

export const selectAuctionState = ({ commit }, auction) => {
  commit('SET_SELECTED_AUCTION', auction);
};

export const fetchAuctionsList = async ({ commit }, data) => {
  try {
    commit('SET_AUCTIONS_LIST', {});
    commit('SET_LOADING', true);
    const response = await auctionsList(data);
    commit('SET_AUCTIONS_LIST', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const fetchAuctionBatchesHistoryList = async ({ commit }, data) => {
  try {
    commit('SET_AUCTIONS_BATCHES_HISTORY_LIST', {});
    commit('SET_LOADING', true);
    const response = await auctionHistoryList(data);
    commit('SET_AUCTIONS_BATCHES_HISTORY_LIST', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const fetchAuctionBatchesList = async ({ commit }, data) => {
  try {
    commit('SET_SELECTED_AUCTION_BATCHES', {});
    commit('SET_LOADING', true);
    const response = await auctionBatchesList(data);
    commit('SET_SELECTED_AUCTION_BATCHES', response.data);
  } finally {
    commit('SET_LOADING', false);
  }
};

export const addAuctionBatches = async ({ commit }, {
  subastaId,
  lotesIds
}) => {
  try {
    commit('SET_LOADING', true);
    return await auctionBatchesAdd({ subastaId, lotes: lotesIds });
  } finally {
    commit('SET_LOADING', false);
  }
};

export const deleteAuctionBatches = async ({ commit }, {
  subastaId,
  lotesIdRemove
}) => {
  try {
    commit('SET_LOADING', true);
    const response = await auctionBatchesDelete({ subastaId, lotes: lotesIdRemove });
    commit('REMOVE_SELECTED_AUCTION_BATCHES', lotesIdRemove);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const updateAuctionStatus = async ({ commit }, {
  subastaId,
  accion
}) => {
  try {
    commit('SET_LOADING', true);
    const response = await auctionsUpdateStatus({ subastaId, accion });
    commit('UPDATE_AUCTION_LIST_STATUS', response.data);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const selectAllElements = ({ commit }, isSelected) => {
  commit('MARK_SELECTED_AUCTIONS', isSelected);
};
